import handleLocale from "./LocaleSwitch";
import { locale } from "./locale/locale";

export const localeISO = handleLocale(locale);
